module.exports = __webpack_public_path__ + "img/carthaginians-barbarian.13a88966.png";